module.exports = __webpack_public_path__ + "img/5.816f2727.png";